import React,{useEffect} from 'react';
import './ServicesPage.css';
import AOS from 'aos';

const ApplicationSoftwareDevelopment = () => {
    useEffect(() => {
        AOS.init();
        
            window.scrollTo(0, 0)
          
      }, [])
  return (
     <div className='container-fluid' id='application-software-development-services'>

    <div className="row first-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
      <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
          <h1>We Provides Top-notch <br />
          "Application Software <br /> Development" Services.</h1>
          <p>"<b>Unique Technologies</b> specializes in crafting bespoke application software solutions, leveraging cutting-edge technology and industry expertise to address specific business needs, streamline processes, and empower clients with innovative digital solutions tailored to their unique requirements."</p>
      </div>
      <div className="col img-col"></div>
    </div>
    <div className="row top-heading-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
          <h2>Our Six Step <br />
          working Process for Application  <br /> Software Development Services</h2>
          <p>Certainly, here's a six-step working process for Application and Software Development offered by <b>Unique Technologies</b></p>
      </div>
  <div className="row second-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="col oddcol first-col">
      <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>1.Requirement Gathering and Analysis: </h3>
              <p>We start by comprehensively understanding your needs, goals, and specifications for the software, ensuring a clear understanding of the project scope and objectives.</p>
          </div>
          <div className="col first-img-col"></div>
      </div>
   </div>
   <div className="col evencol second-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col second-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>2.Planning and Design: </h3>
              <p>Our team works closely with you to devise a detailed project plan, including architecture design, user interface layout, and feature prioritization, ensuring alignment with your business objectives.</p>
          </div>

      </div>
   </div>
   <div className="col oddcol third-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>3.Development and Coding: </h3>
              <p>Skilled developers then commence coding, utilizing the latest technologies and best practices to build robust, scalable, and feature-rich software solutions that meet your requirements and exceed expectations.</p>
          </div>
          <div className="col third-img-col"></div>
      </div>
   </div>
   <div className="col evencol fourth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col fourth-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>4.Testing and Quality Assurance: </h3>
              <p>Rigorous testing is conducted at every stage of development to identify and rectify any bugs or issues, ensuring the software functions flawlessly and delivers a seamless user experience.</p>
          </div>

      </div>
   </div>
   <div className="col oddcol fifth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>5.Deployment and Implementation: </h3>
              <p>Upon successful testing, we deploy the software to your infrastructure or preferred platform, meticulously managing the implementation process to ensure minimal disruption and optimal performance.</p>
          </div>
          <div className="col fifth-img-col"></div>
      </div>
   </div>
   <div className="col evencol sixth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col sixth-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>6.Maintenance and Support: </h3>
              <p>Our commitment extends beyond deployment, as we provide ongoing maintenance and support services to address any issues, implement updates, and ensure the software continues to meet your evolving needs effectively.</p>
          </div>

      </div>
   </div>
  </div>
  </div>
  )
}

export default ApplicationSoftwareDevelopment;
